<div class="add-notes-container">
    <div class="add-notes-header">
        <!-- <h4>Add Notes</h4> -->
        <h4>{{alertVarService.titles.templateTitles.add_notes.add_notes}}</h4>
    </div>
    <div class="add-notes-body">
        <div class="custom-search">
            <img src="assets/search-small.svg">
            <input type="search" placeholder="Type to search here" [formControl]="searchValue">
        </div>
        <div class="notes-list">
            <ul *ngIf="filteredNotes.length">
                <ng-container *ngFor="let note of filteredNotes; index as i">
                    <li [ngClass]="selectedNote==note? 'highlight-note':''" (click)="selectNote(note)">{{note}}</li>
                </ng-container>
            </ul>
            <p *ngIf="!filteredNotes.length" class="no-notes">{{alertVarService.titles.templateTitles.add_notes.no_result}}</p>
        </div>
        <ng-container *ngIf="addNoteSpinnerState">
            <div class="add-notes-spinner">
                <mat-spinner class="spinner" diameter=20></mat-spinner>
            </div>
        </ng-container>
    </div>
    <div class="add-notes-footer">
        <div class="footer-buttons">
            <button class="cancel-button" (click)="cancelNotes()">{{alertVarService.titles.templateTitles.add_notes.cancel}}</button>
            <button class="submit-button" (click)="submitAddNote()">{{alertVarService.titles.templateTitles.add_notes.submit}}</button>
        </div>
    </div>
</div>